import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Address from 'components/Address';
import Button from 'components/Button';
import Paper from 'components/Paper';

const StyledAddressDeleteConfirmView = styled.div`
  > * {
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }

  .Address {
    li:first-child{
        font-family: ${({ theme }) => theme.typography.h3.fontFamily};
        font-weight: ${({ theme }) => theme.typography.h3.fontWeight};
        font-size: ${({ theme }) => theme.typography.h3.fontSize};
      }
  }
`;

const AddressDeleteConfirmView = ({
  className, address, onCancel, onDelete,
}) => {
  const classes = ['AddressDeleteConfirmView', className];
  return (
    <StyledAddressDeleteConfirmView
      className={classes.filter((c) => !!c).join(' ')}
    >
      <h1>Delete address</h1>
      <p>No longer need this address?</p>
      <Paper>
        {address && <Address address={address} />}
      </Paper>
      <Button
        onClick={onDelete}
        fullWidth
      >
        Delete Address
      </Button>
      <Button
        onClick={onCancel}
        inverse
        fullWidth
        dataLayer={{ action: 'Make This My Primary Address', label: 'Cancel' }}
      >
        Cancel
      </Button>
    </StyledAddressDeleteConfirmView>
  );
};

AddressDeleteConfirmView.displayName = 'AddressDeleteConfirmView';

AddressDeleteConfirmView.propTypes = {
  className: PropTypes.string,
  address: PropTypes.shape({}),
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

AddressDeleteConfirmView.defaultProps = {
  className: null,
  address: null,
};

export default AddressDeleteConfirmView;
//maybe you want to make address required...
